import React, { Component } from "react";
import { Box } from "@mui/material";
import "../styles/index.css";

class Avatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageSrc:
        props.avatar || "https://cdn-icons-png.flaticon.com/512/149/149071.png",
      socialType: props.socialType,
    };
  }

  componentDidMount() {
    this.checkImage(this.props.avatar);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.avatar !== this.props.avatar) {
      this.checkImage(this.props.avatar);
    }
  }

  checkImage(url) {
    const img = new Image();
    img.src = url;
    img.onload = () => {
      this.setState({ imageSrc: url });
    };
    img.onerror = () => {
      this.setState({
        imageSrc: "https://cdn-icons-png.flaticon.com/512/149/149071.png",
      });
    };
  }

  render() {
    const { socialType, imageSrc } = this.state;
    const { width, height } = this.props;
    // Keep the avatar perfectly circular even if only one dimension is provided
    const sizeW = width || height || "71px";
    const sizeH = height || width || "71px";
    let borderClass;

    switch (socialType) {
      case "instagram":
        borderClass = "instagram-border";
        break;
      case "facebook":
      case "linkedin":
        borderClass = "facebook-border";
        break;
      case "tiktok":
        borderClass = "tiktok-border";
        break;
      case "telegram":
        borderClass = "telegram-border";
        break;
      case "reddit":
        borderClass = "reddit-border";
        break;
      case "twitter":
        borderClass = "twitter-border";
        break;
      case "youtube":
        borderClass = "youtube-border";
        break;
      default:
        borderClass = "";
        break;
    }

    return (
      <React.Fragment>
        <Box
          className={`avatar-wrapper ${borderClass}`}
          sx={{
            width: sizeW,
            height: sizeH,
            borderRadius: "50%",
            overflow: "hidden",
            display: "inline-block",
            boxSizing: "border-box",
            aspectRatio: "1 / 1",
            flexShrink: 0,
            flexGrow: 0,
          }}>
          <img
            src={imageSrc}
            className="avatar"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
            alt=""
          />
        </Box>
      </React.Fragment>
    );
  }
}

export default Avatar;
